"use client";

import React from "react";
import { MessageCircle, Loader2, CheckCircle2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const formFields = [{
  key: "name",
  label: "Adınız Soyadınız",
  type: "text",
  required: true,
  placeholder: "Ayşegül İnneci",
  help_text: ""
}, {
  key: "phone",
  label: "Telefon Numarası",
  type: "tel",
  required: true,
  placeholder: "+90 5xx xxx xxxx",
  help_text: "İletişim kurabilmemiz için geçerli bir telefon numarası giriniz.",
  validation: {
    pattern: "phone"
  }
}, {
  key: "email",
  label: "E-posta Adresi",
  type: "email",
  required: true,
  placeholder: "example@domain.com",
  help_text: ""
}, {
  key: "appointment_date",
  label: "İstediğiniz Randevu Tarihi",
  type: "date",
  required: true,
  placeholder: "",
  help_text: "Kanal Tedavisi için uygun bir tarih seçiniz."
}, {
  key: "message",
  label: "Ek Notlar / Sorular",
  type: "textarea",
  required: false,
  placeholder: "Ağrı, ilaç bilgileri vb. ek bilgi...",
  help_text: ""
}];
function AppointmentFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center space-y-4 py-12 text-center animate-in fade-in zoom-in duration-500">
        <div className="rounded-full bg-primary/10 p-3">
          <CheckCircle2 className="size-12 text-primary" />
        </div>
        <h3 className="font-serif text-2xl font-medium text-foreground">
          Teşekkürler!
        </h3>
        <p className="text-muted-foreground max-w-md">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-6 border-primary/20 hover:bg-primary/5">
          Yeni Bir Randevu Al
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <div className="grid gap-8 md:grid-cols-2">
        {formFields.map((field, i) => <FormField key={field.key} control={control} name={field.key} rules={{
        required: field.required ? `${field.label} zorunludur` : false,
        ...(field.validation?.pattern === "phone" ? {
          pattern: {
            value: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
            message: "Geçerli bir telefon numarası giriniz"
          }
        } : {})
      }} render={({
        field: renderField
      }) => <FormItem data-index={i} className={field.type === "textarea" ? "md:col-span-2" : ""}>
                <FormLabel className="text-foreground/80 font-medium">
                  {field.label}
                  {field.required && <span className="text-primary ml-1">*</span>}
                </FormLabel>
                <FormControl>
                  {field.type === "textarea" ? <textarea className="flex min-h-[100px] w-full border-0 border-b border-primary/30 bg-transparent py-2 text-base text-foreground placeholder:text-muted-foreground/50 focus-visible:outline-none focus-visible:border-primary focus-visible:ring-0 resize-none transition-colors" placeholder={field.placeholder} {...renderField} /> : <input type={field.type} className="flex w-full border-0 border-b border-primary/30 bg-transparent py-2 text-base text-foreground placeholder:text-muted-foreground/50 focus-visible:outline-none focus-visible:border-primary focus-visible:ring-0 transition-colors" placeholder={field.placeholder} {...renderField} />}
                </FormControl>
                {field.help_text && <FormDescription className="text-xs text-muted-foreground/70">
                    {field.help_text}
                  </FormDescription>}
                <FormMessage />
              </FormItem>} />)}
      </div>

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-destructive text-sm text-center">{submitError}</p>
        </div>}

      <div className="pt-4">
        <Button type="submit" disabled={isSubmitting} className="w-full h-14 text-lg font-medium bg-gradient-to-r from-primary to-accent-foreground text-primary-foreground rounded-[2px] hover:shadow-[0_0_20px_var(--color-primary)] hover:shadow-primary/40 transition-all duration-300 border-0">
          {isSubmitting ? <>
              <Loader2 className="animate-spin mr-2 size-5" />
              Gönderiliyor...
            </> : "Randevu Oluştur"}
        </Button>
      </div>
    </Form>;
}
export default function RandevuAl() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}